import { render, staticRenderFns } from "./ContentParser.vue?vue&type=template&id=ef113624"
import script from "./ContentParser.vue?vue&type=script&lang=js"
export * from "./ContentParser.vue?vue&type=script&lang=js"
import style0 from "./ContentParser.vue?vue&type=style&index=0&id=ef113624&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports